import styles from "./Tabs.module.css";

export type TabItem = {
  value: string;
  label: string;
  count?: number;
};

export type TabsProps = {
  value: string;
  onChange: (value: string) => void;
  items: TabItem[];
};

export const Tabs = ({ value, onChange, items }: TabsProps) => (
  <div role="tablist" className={styles.tabs}>
    {items.map((it) => {
      const active = it.value === value;
      return (
        <button
          key={it.value}
          type="button"
          role="tab"
          aria-selected={active}
          data-active={active ? "true" : "false"}
          className={styles.tab}
          onClick={() => onChange(it.value)}
        >
          <span>{it.label}</span>
          {it.count !== undefined && <span className={styles.count}>{it.count}</span>}
        </button>
      );
    })}
  </div>
);
